import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuthStore } from "./store/auth";
import { useProdutosStore } from "./store/produtos";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import RegisterForm from "./components/RegisterForm";
import PublicRegister from "./components/PublicRegister";
import ClinicaRegister from "./components/MedicoRegister";
import RepresentanteRegister from "./components/RepresentanteRegister";
import PacienteRegister from "./components/PacienteRegister";
import EsqueceuSenha from "./components/EsqueceuSenha";
import FinalizeRepresentativeRegistration from "./components/FinalizeRepresentativeRegistration"; // Importe o novo componente
import ResetarSenha from "./components/ResetarSenha"; // 1. Importar o novo componente
import FinalizeClinicRegistration from "./components/FinalizeClinicRegistration";
import NetworkStatus from "./components/NetworkStatus";
import PortalSelector from "./components/PortalSelector";
function App() {
  const { user, loading, checkAuth } = useAuthStore();
  const { carregarProdutos } = useProdutosStore();
  const [registerType, setRegisterType] = useState(null);
  const [selectedPortal, setSelectedPortal] = useState(() => {
    // 1. Prioridade máxima para a variável de ambiente do build.
    const portalFromEnv = import.meta.env.VITE_APP_PORTAL;
    if (portalFromEnv) {
      return portalFromEnv;
    }
    // 2. Se não houver variável de ambiente (modo dev), verifica a URL.
    const urlParams = new URLSearchParams(window.location.search);
    const portalFromUrl = urlParams.get("portal");
    if (portalFromUrl === "paciente" || portalFromUrl === "backoffice") {
      return portalFromUrl;
    }
    // 3. Se não houver nada, retorna null para mostrar o seletor.
    return null;
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const pathname = window.location.pathname;
    const registerParam = urlParams.get("register");
    const forgotPasswordParam = urlParams.get("forgot-password");

    if (pathname === "/cadastro/representante/finalizar") {
      setRegisterType("finalize-representative"); // Novo tipo para esta rota específica
    } else if (pathname === "/resetar-senha") {
      setRegisterType("reset-password");
    } else if (pathname === "/cadastro/clinica/finalizar") {
      setRegisterType("finalize-clinic");
    } else if (registerParam) {
      setRegisterType(registerParam);
    } else if (forgotPasswordParam) {
      setRegisterType("forgot-password");
    }
  }, []);

  useEffect(() => {
    const loadAfterLogin = async () => {
      if (user) {
        await carregarProdutos();
      }
    };

    loadAfterLogin();
  }, [user, carregarProdutos]);
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-center"
        >
          <div className="w-16 h-16 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <h2 className="text-xl md:text-2xl font-bold text-emerald-800 mb-2">
            GreenClub
          </h2>
          <p className="text-gray-600">Carregando...</p>
        </motion.div>
      </div>
    );
  }
  if (registerType === "clinica" || registerType === "medico") {
    return <ClinicaRegister />;
  }

  if (registerType === "representante") {
    return <RepresentanteRegister />;
  }

  if (registerType === "paciente") {
    return <PacienteRegister />;
  }

  if (registerType === "forgot-password") {
    return <EsqueceuSenha />;
  }

  if (registerType === "public") {
    return <PublicRegister />;
  }

  if (registerType === "finalize-representative") {
    return <FinalizeRepresentativeRegistration />;
  }

  if (registerType === "finalize-clinic") {
    return <FinalizeClinicRegistration />;
  }

  // 3. Adicionar a condição para renderizar a página de reset
  if (registerType === "reset-password") {
    return <ResetarSenha />;
  }

  const renderContent = () => {
    if (!user) {
      if (selectedPortal === null && !registerType) {
        // O seletor só aparece se VITE_APP_PORTAL não estiver definido
        return <PortalSelector onSelectPortal={setSelectedPortal} />;
      }

      return <Login portal={selectedPortal} />;
    }

    if (user.needsRegistration) {
      return <RegisterForm />;
    }

    return <Dashboard />;
  };

  const getContentKey = () => {
    if (!user) {
      return selectedPortal ? `login-${selectedPortal}` : "portal-selector";
    }

    return user.needsRegistration ? "register" : "dashboard";
  };

  return (
    <div className="App">
      <NetworkStatus />
      <AnimatePresence mode="wait">
        <motion.div
          key={getContentKey()}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {renderContent()}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default App;
